var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-400 text-large"},[_c('div',{staticClass:"error-400__message"},[_vm._v("システムエラーが発生しました。最初からやり直してください。")]),_c('a',{attrs:{"href":_vm.returnPage}},[_vm._v("戻る")])])
}
var staticRenderFns = []

export { render, staticRenderFns }